const fontColorClasses = {
    Gradient: 'gradient-font',
    Black: 'black-font',
    Burgundy: 'burgundy-font',
    Purple: 'purple-font',
};
const fontSizeClasses = {
    '1em': 'fs-1',
    '1.125em': 'fs-1125',
    '1.25em': 'fs-125',
    '1.375em': 'fs-1375',
    '1.5em': 'fs-15',
    '2rem': 'fs-2',
    Small: 'small-font',
    Medium: 'medium-font',
    Large: 'large-font',
};
const marginBottomClasses = {
    '0': 'mb-0',
    '0.5em': 'mb-05',
    '1em': 'mb-1',
    '1.5rem': 'mb-15',
    '3em': 'mb-3',
};
const marginTopClasses = {
    '0': 'mt-0',
    '0.5em': 'mt-05',
    '1em': 'mt-1',
    '3em': 'mt-3',
};
const textAlignClasses = {
    center: 'text-align-c',
    left: 'text-align-l',
    right: 'text-align-r',
};
const paddingClasses = {
    '0': 'p-0',
    '1em': 'p-1',
    '2em': 'p-2',
};
const borderRadiusClasses = {
    '0': 'br-0',
    '0.5em': 'br-05',
    '1em': 'br-1',
};
const sizeClasses = {
    Default: '',
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
};
const WidthTemplates = ['default', 'fullWidth'];
function getStyleClassNames({ fontSize, fontColor, padding, marginBottom, marginTop, textAlign, borderRadius, forceWideAspect, withBorder, isRtl, additionalClasses, }) {
    const paddingClass = padding ? paddingClasses[padding] : '';
    const fontSizeClass = fontSize ? fontSizeClasses[fontSize] : '';
    const fontColorClass = fontColor ? fontColorClasses[fontColor] : '';
    const marginBottomClass = marginBottom
        ? marginBottomClasses[marginBottom]
        : '';
    const marginTopClass = marginTop ? marginTopClasses[marginTop] : '';
    const textAlignClass = textAlign ? textAlignClasses[textAlign] : '';
    const borderRadiusClass = borderRadius
        ? borderRadiusClasses[borderRadius]
        : '';
    const wideAspectClass = forceWideAspect ? 'wideAspect' : '';
    const withBorderClass = withBorder ? 'border' : '';
    const isRtlClass = isRtl ? 'text-align-right' : '';
    const additionalClassesClass = additionalClasses || '';
    return `${paddingClass} ${fontSizeClass} ${fontColorClass} ${marginBottomClass} ${marginTopClass} ${textAlignClass} ${borderRadiusClass} ${wideAspectClass} ${withBorderClass} ${isRtlClass} ${additionalClassesClass}`;
}

export { WidthTemplates, borderRadiusClasses, fontColorClasses, fontSizeClasses, getStyleClassNames, marginBottomClasses, marginTopClasses, paddingClasses, sizeClasses, textAlignClasses };
